export var ConnectionType;

(function (ConnectionType) {
  ConnectionType["ImTokenCallApp"] = "imToken Call App";
  ConnectionType["ImTokenWalletConnect"] = "imToken Wallet Connect";
  ConnectionType["Injected"] = "Injected";
  ConnectionType["Network"] = "Network";
  ConnectionType["WalletConnectV2"] = "WalletConnect V2";
  ConnectionType["GnosisSafe"] = "Gnosis Safe";
  ConnectionType["ImKey"] = "ImKey";
  ConnectionType["Coinbase"] = "Coinbase";
})(ConnectionType || (ConnectionType = {}));